import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type ActionFooterBoardVisibilityFragment = (
  { __typename: 'Board' }
  & Pick<Types.Board, 'id' | 'name' | 'shortLink'>
  & { prefs?: Types.Maybe<(
    { __typename: 'Board_Prefs' }
    & Pick<Types.Board_Prefs, 'permissionLevel'>
  )> }
);

export const ActionFooterBoardVisibilityFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionFooterBoardVisibility' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prefs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissionLevel' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'shortLink' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseActionFooterBoardVisibilityFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      ActionFooterBoardVisibilityFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseActionFooterBoardVisibilityFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<ActionFooterBoardVisibilityFragment>,
    'data'
  > {
  data?: ActionFooterBoardVisibilityFragment;
}

export const useActionFooterBoardVisibilityFragment = ({
  from,
  returnPartialData,
  ...options
}: UseActionFooterBoardVisibilityFragmentOptions): UseActionFooterBoardVisibilityFragmentResult => {
  const result = Apollo.useFragment<ActionFooterBoardVisibilityFragment>({
    ...options,
    fragment: ActionFooterBoardVisibilityFragmentDoc,
    fragmentName: 'ActionFooterBoardVisibility',
    from: {
      __typename: 'Board',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return {
    ...result,
    data: result.data as ActionFooterBoardVisibilityFragment,
  };
};
